module.exports = __webpack_public_path__ + "img/streetsmap.327fd4a7.jpg";